<anecdotes-comment-input
  #textInput
  class="text-input group w-full outline-none bg-transparent"
  [usersMap]="usersMap"
  [editable]="editable"
  [placeholder]="placeholder"
  [formControl]="textControl"
  (linkClick)="linkClick($event)"
  (focusin)="focusIn()"
  (focusout)="focusOut()"
>
  <ng-template #optionTemplate let-user="user" let-isFocused="isFocused">
    <app-dropdown-option [selected]="isFocused">
      <app-commenting-user-logo [userId]="user.id" [fallbackUserName]="user.name"></app-commenting-user-logo>
      <span
        class="overflow-hidden overflow-ellipsis whitespace-nowrap"
        placement="top"
        [ngbTooltip]="user.name"
        [openTooltipWhenOverflowedAndHovered]="true"
        [openOnWidthOverflow]="true"
      >
        {{ user.name }}
      </span>
    </app-dropdown-option>
  </ng-template>
</anecdotes-comment-input>

@if (shouldDraftBeVisible) {
  <span class="draft-text" [class.draft-long]="isDraftLong">{{ buildTranslationKey('draft') | translate }}</span>
}
